import { lazy } from "react"

const Fisco = lazy(() => import('../../views/pages/settings/agency/Fisco'))
const ManagePlu = lazy(() => import('../../views/pages/settings/assets/ManagePlu'))
const Department = lazy(() => import('../../views/pages/settings/environment/Department'))
const OrganizationList = lazy(() => import('../../views/pages/settings/environment/OrganizationList'))
const WareHouses = lazy(() => import('../../views/pages/settings/environment/WareHouses'))
const Catalogs = lazy(() => import('../../views/pages/settings/products-services/Catalogs'))
const Categories = lazy(() => import('../../views/pages/settings/products-services/Categories'))
const Diz = lazy(() => import('../../views/pages/settings/products-services/Diz'))
const ImportProducts = lazy(() => import('../../views/pages/settings/products-services/ImportProducts'))
const SerialBatches = lazy(() => import('../../views/pages/settings/products-services/SerialBatches'))
const GeneralUsers = lazy(() => import('../../views/pages/settings/staff/GeneralUsers'))
const QuickActions = lazy(() => import('../../views/pages/quick-action/QuickActions'))
const MultipleDDT = lazy(() => import('../../views/pages/quick-action/MultipleDDT'))
const PricePlu = lazy(() => import('../../views/pages/quick-action/PricePlu'))
const SendingStatus = lazy(() => import('../../views/pages/quick-action/SendingStatus'))

const SettingsRoutes = [
    {
        element: <Fisco />,
        path: '/iva'
    },
    {
        element: <ManagePlu />,
        path: '/manage-plu'
    },
    {
        element: <Department />,
        path: '/department'
    },
    {
        element: <OrganizationList />,
        path: '/organization-list'
    },
    {
        element: <WareHouses />,
        path: '/warehouses'
    },
    {
        element: <Catalogs />,
        path: '/Catalogs'
    },
    {
        element: <Categories />,
        path: '/Categories'
    },
    {
        element: <Diz />,
        path: '/Diz'
    },
    {
        element: <ImportProducts />,
        path: '/import-products'
    },
    {
        element: <SerialBatches />,
        path: '/serial-batches'
    },
    {
        element: <GeneralUsers />,
        path: '/general-users'
    },
    {
        element: <QuickActions />,
        path: '/quick-actions'
    },
    {
        element: <MultipleDDT />,
        path: '/load-multiple-ddt'
    },
    {
        element: <PricePlu />,
        path: '/load-price-plu'
    },
    {
        element: <SendingStatus />,
        path: '/sending-status'
    }
]
export default SettingsRoutes